import { FunctionComponent } from 'preact';

interface AssetPlaceholderProps {
  disableDescription?: boolean;
}

export const AssetPlaceholder: FunctionComponent<AssetPlaceholderProps> = ({
  disableDescription,
}) => {
  const showDescription = !disableDescription;

  return (
    <div className="vgp-asset-placeholder">
      <div className="vgp-asset-placeholder-thumbnail" />
      <div className="vgp-asset-placeholder-details">
        <div className="vgp-asset-placeholder-label" />
        <div className="vgp-asset-placeholder-headline" />
        {showDescription && (
          <div className="vgp-asset-placeholder-description" />
        )}
      </div>
    </div>
  );
};
